export default __webpack_public_path__ + "static/media/external-link-active.be16ddf4.svg";